import styled from 'styled-components'

export const MainContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${props => props.theme.spacing.sp16};
`

export const StoresContainer = styled.div`
  display: grid;
  grid-template-columns: ${props =>
    props.storesCount <= 3 ? `repeat(${props.storesCount}, 1fr)` : `repeat(auto-fill, minmax(300px, 1fr))`};

  gap: ${props => props.theme.spacing.sp16};
`
